import React, { useContext, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Flex, Box, Heading, Text, Button, Link as ExternalLink } from 'rebass/styled-components'
import { Checkbox } from '@rebass/forms'
// Styled components checkbox doesn't work so utilising ThemeContext to style standard rebass component.
import { ThemeContext } from 'styled-components'
import { Input, Textarea, Label } from '@rebass/forms/styled-components'
import { useForm } from 'react-hook-form';


const CarForm = ({ sendMail, product }) => {
    const url = typeof window !== 'undefined' ? window.location.href : 'Referring URL not available'
    const { register, handleSubmit, setValue, formState: { errors }} = useForm();
    const onSubmit = (data) => sendMail(data, 'car_enquiry');
    const theme = useContext(ThemeContext);
    const [vehicle, setProduct] = useState(null)

    useEffect(() => {
        setValue('vehicle', product ? product.title : '')
        setValue('model', product ? product.title : '')
        setValue('chassis', product ? product.characteristics.chassis.number : '')
        setValue('engine', product ? product.characteristics.engine.number : '')
        setProduct(product)
    }, [product])

    return (
        <Flex
            alignItems="flex-start"
            flexDirection="column"
            justifySelf="center"
            id="enquire"
            name="carFormRef" // This is for ScrollTo to work.
            variant="container"
            maxWidth="1160px"
            mb="lg"
            pt="md"
            pb="md"
            px="md"
        >
            <Flex
                alignItems="flex-start"
                flexDirection='row'
                mb="md"
                width="100%"
            >
                <Box
                    alignSelf="stretch"
                    flexGrow="1"
                    flexShrink="0"
                >
                    <Heading as="h2" variant="h2"
                        sx={{
                            marginBottom: 0,
                            textTransform: 'uppercase',
                        }}>Car enquiry</Heading>
                </Box>
                <Box
                    alignSelf="flex-end"
                    display={['none', 'none', 'block']}
                >
                    <ExternalLink href="mailto:info@kidston.com"
                        sx={{
                            color: 'black',
                        }}>info@kidston.com</ExternalLink>
                </Box>
            </Flex>
            {
                (vehicle) ?
                    <Flex
                        alignContent="space-between"
                        alignItems="flex-start"
                        onSubmit={handleSubmit(onSubmit)}
                        as="form"
                        autocomplete="on"
                        flexDirection={['column', 'column', 'column', 'row']}
                        width="100%"
                        flexGrow="1"
                    >
                        {/* TODO: inject vehicle; model, chassis and engine number values into hidden inputs */}
                        <Input type="hidden" name="subject" value="Car Enquiry" {...register('subject')} />
                        <Input type="hidden" name="referrer" value={url} {...register('referrer')} />
                        <Box
                            mr={['0', '0', 'sm', 'sm', 'md']}
                            width="100%"
                        >
                            <Text
                                as="label"
                                htmlFor="form-name"
                                hidden
                            >
                                Name
                            </Text>
                            <Input autoComplete="name" enterKeyHint="next" id="form-name" type="text" name="from_name" placeholder="Name" {...register('from_name', { required: true })} />
                            {errors.from_name && <span className="errorMessage">Please enter your name.</span>}

                            <Text
                                as="label"
                                htmlFor="form-email"
                                hidden
                            >
                                Email
                            </Text>
                            <Input autoComplete="email" enterKeyHint="next" id="form-email" type="email" name="reply_to" placeholder="Email" {...register('reply_to', { required: true })} />
                            {errors.reply_to && <span className="errorMessage">Please enter a valid email.</span>}

                            <Text
                                as="label"
                                htmlFor="form-tel"
                                hidden
                            >
                                Telephone
                            </Text>
                            <Input autoComplete="tel" enterKeyHint="next" id="form-tel" type="tel" name="phone" placeholder="Phone" {...register('phone', { required: true })} />
                            {errors.phone && <span className="errorMessage">Please enter your contact number.</span>}
                        </Box>
                        <Box
                            mt={['md', 'md', '0']}
                            ml={['0', '0', 'sm', 'sm', 'md']}
                            width="100%"
                        >
                            <Text
                                as="label"
                                htmlFor="form-comments"
                                hidden
                            >
                                Comments
                            </Text>
                            <Textarea
                                enterKeyHint="next"
                                id="form-comments"
                                name="message"
                                placeholder="Comments"
                                type="textarea" {...register('message', { required: true })}
                                sx={{
                                    borderColor: 'aquaMedium',
                                    overflow: 'auto',
                                    minHeight: '114px',
                                    resize: 'vertical',
                                }}
                            />
                            {errors.message && <span className="errorMessage">Please write a brief message so we can respond as swiftly as possible.</span>}
                            <Flex
                                alignItems="center"
                                justifyContent="space-between"
                            >
                                <Button
                                    aria-pressed="false"
                                    enterKeyHint="done"
                                    mr="auto"
                                    mt="md"
                                    type="submit"
                                    variant="primary"
                                >Submit</Button>
                                <Box
                                    mt="md">
                                    <Label>
                                        <Flex
                                            alignItems="center"
                                        >
                                            <Text
                                                mx="xs"
                                            >Add me to the Newsletter</Text>
                                        </Flex>
                                        <Flex>
                                            <Checkbox
                                                id="newsletter_consent"
                                                name="newsletter_consent" {...register('newsletter_consent', { required: false })}
                                                mr="0"
                                                sx={{
                                                    'input:checked ~ &': {
                                                        color: theme.colors.aquaDark,
                                                    },
                                                    color: theme.colors.aquaDark,
                                                }
                                                }
                                            />
                                        </Flex>
                                    </Label>
                                </Box>
                            </Flex>
                        </Box>
                    </Flex> :
                    null
            }
        </Flex>
    )
}

function mapStateToProps(state) {
    return {
        product: state.Products && state.Products.product,
    }
}
export default connect(mapStateToProps)(CarForm)
